import CycleMeasurementTable from './CycleMeasurementTable'
import PaginatedTable from '../../tables/PaginatedTable';
import InfoExperimentalProcedureViewer from './InfoExperimentalProcedureViewer';

import '../../css_styles/button_styles.css'
import { useEffect, useState } from 'react';


function DisplayCycleMeasurement(props) {
    
    const [rows, setRows] = useState([]);
    function transpose(matrix) {
        return matrix[0].map((_, columnIndex) => matrix.map(row => row[columnIndex]));
    }
    
    let show_uploaded_candiates = (<></>)
    
    if (props.cycleMeasurement.length>0){
        show_uploaded_candiates = props.cycleMeasurement.map( (data, data_id) => {

        let colNames = data.csv_data.columns.map( (col) => {
            if (col.units !== ''){
                return `${col.name} [${col.units}]`
            }
            else {
                return `${col.name}`
            }
        });
        let tableRows = data.csv_data.columns.map( (col) => col.vals);
        tableRows =transpose(tableRows);

        return (<>

                <div style = {{fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'10px', height:'fit-content', width:'95%', overflow:'auto'}}>
                    <CycleMeasurementTable
                            colNames={colNames}
                            tableRows={tableRows}
                            itemsPerPage={15}
                            displayPrecision={props.displayPrecision}
                            // actionsOnSelect={action_panel_raw_data}
                            // onSelect={onSelectRawData}
                            handleDisplayPrecision={props.handleDisplayPrecision}
                            // handleCustomDesignInput={props.handleCustomDesignInput}
                            />

                <div style = {{display:'flex',marginLeft:'0px', marginBottom:'15px', marginTop:'5px', gap:'10px'}} >
                    <button className={'actionButtonSmall'} style={{width:'150px', margin:'0px', marginLeft:'0px'}} onClick={props.handleExportTableXLS} >Export Table .xlsx</button>
                </div>
                    
                <div style={{marginLeft:'0px', marginBottom:'10px', fontSize:'14px'}}>Data record uuid: {data.uuid_training_data}</div>
                {/* <div style={{marginLeft:'0px', marginBottom:'10px', fontSize:'14px'}}>Experimental Setup uuid: {props.experimentalProcedure[data_id].uuid_experimental_setup}</div> */}
                <InfoExperimentalProcedureViewer 
                    width={props.width}
                    uuidExpSetup={props.experimentalProcedure[data_id].uuid_experimental_setup}
                    description={props.experimentalProcedure[data_id].procedure}
                    />
                </div>
            </>);
        });
    }

    
    useEffect(() => {
        let table_rows = props.rawDataFiles.map((raw_data, id) => {

            let filename_link = (<>
                <button id={`download_${id}`} className={'downloadLink'} onClick={props.downloadFile}>
                    {raw_data.filename}
                </button></>)

            return {filename: filename_link, uuid: raw_data.uuid_training_data}
        
    });
        setRows(table_rows);

    }, [props.rawDataFiles, props.downloadFile]);

    let show_uploaded_raw_data = (<></>);

    show_uploaded_raw_data = (<>
                 <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'10px', width:'fit-content'}} >
                    Uploaded Raw Data Files 
                </h4>
                <div style = {{fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'25px', height:'fit-content', width:'95%', overflow:'auto'}}>
                    <PaginatedTable
                        colNames={['File Name', 'Uploaded with data record (uuid)']}
                        tableRows={rows}
                        itemsPerPage={15}
                        />
                </div>
                </>);



    return (<>

            <div style = {{width: `${props.width * 0.91 - 20}px`, marginLeft: '20px', background: 'white', marginTop: '10px', marginBottom: '0px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'10px', width:'fit-content'}} >
                            Display Cycle Measurements 
                </h4>
                    {show_uploaded_candiates}
                    {show_uploaded_raw_data}

            </div>
        </>);
    }

export default DisplayCycleMeasurement